import React, { FC, memo, useEffect, useState } from 'react';
import { LegacyAgency } from 'src/interfaces/api/Agency';
import LegacyAgencySelect from './LegacyAgencySelect';
import useAuth from 'src/hooks/api/useAuth';

const apiAgency = '/api/agency/';

interface Props {
  className?: any;
  multiple?: boolean;
}

interface MultipleSelectProps extends Props {
  multiple: true;
  agencyId: number[];
  onChange: (agencyId: number[]) => void;
}

interface SingleSelectProps extends Props {
  multiple?: false;
  agencyId: number;
  onChange: (agencyId: number) => void;
}

const LegacyAgencySelectContainer: FC<SingleSelectProps | MultipleSelectProps> = ({ ...props }) => {
  const [agencies, setAgencies] = useState<Omit<LegacyAgency, 'siret'>[]>([]);
  const { fetch } = useAuth();

  const fetchAgencies = () => {
    fetch(apiAgency + '{agencies{ id, name }}', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        }

        throw new Error('Scaleed - Unabled to fetch agencies');
      })
      .then((result) => {
        setAgencies(result.data?.agencies || []);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchAgencies();
  }, []);

  return <LegacyAgencySelect agencies={agencies} {...props} />;
};

export default memo(LegacyAgencySelectContainer, (prevProps, nextProps) => prevProps.agencyId === nextProps.agencyId);
